import { IMasterData, ISelectItem } from "@/types";

export class MasterData implements IMasterData {
  public readonly id = 0;
  public name = "";

  public constructor(props?: IMasterData) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(item: IMasterData): ISelectItem {
    return {
      text: item.name,
      value: item.id,
    };
  }
}
